module.exports = __webpack_public_path__ + "static/media/19ESCAP39.f1d035ef.jpg";